var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.816 6.059a11.782 11.782 0 005.126 5.126l1.711-1.711a.773.773 0 01.793-.187 8.872 8.872 0 002.777.443.78.78 0 01.778.778v2.714a.78.78 0 01-.778.778A13.221 13.221 0 010 .778.78.78 0 01.778 0H3.5a.78.78 0 01.778.778 8.836 8.836 0 00.443 2.777.781.781 0 01-.194.793z",
    fill: "#5f48e9"
  })));
}

export default SvgPhone;